import createError from '../createError';
import type {ValidatorError, CommonInput} from '../types';

export function commonValidators(value: CommonInput, field: string) {
  return {
    required: () => required(value, field),
  };
}

const required = (value: CommonInput, field: string): ValidatorError => {
  return createError(
    value,
    field,
    'required',
    (value: CommonInput) => value === '' || value === null
  );
};
